import React from 'react';
import styled from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import PostCard from '@/components/PostCard';

function PostsList() {
  const page = useTypedSelector(selectSinglePost);

  if (!page || !page.relatedPosts || page.relatedPosts.length === 0) {
    return null;
  }

  return (
    <Component>
      {page.relatedPosts.map(({ url, title, image }, index) => (
        <PostCard
          key={index}
          title={title ?? ''}
          url={url ?? ''}
          image={image}
        />
      ))}
    </Component>
  );
}

export default PostsList;

const Component = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 20px;
`;
